import React, { useRef, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { ApolloProvider, ApolloClient, InMemoryCache, gql, useMutation, HttpLink } from "@apollo/client";
import ContactFromDate from "data/sections/form-info.json";
import { createUploadLink } from 'apollo-upload-client';

const JobModal = ({ oppturtunityData, ...props }) => {
  const APOLLO_CLIENT = new ApolloClient({
    link: createUploadLink({ uri: process.env.GATSBY_API_URL }), // your GraphQL endpoint
    cache: new InMemoryCache(),
  });
  

  // GraphQL mutation query
  const CREATE_JOB_APPLICATION = gql`
    mutation CreatejobApplicationMutation($fullName: String!, $email: String!, $contact: String!, $exp: String!, $current_Loc: String!, $file: Upload, $photo: Upload) {
      createJobapplication(input: { fullName: $fullName, email: $email, contact: $contact, exp: $exp, current_Loc: $current_Loc, file: $file, photo: $photo }) {
        success
        data
      }
    }
  `;

  const JobForm = () => {
    const formRef = useRef(null);
    const [fullNameValue, setFullNameValue] = useState("");
    const [emailValue, setEmailValue] = useState("");
    const [contactValue, setContactValue] = useState("");
    const [expValue, setExpValue] = useState("");
    const [currentLocation, setCurrentLocation] = useState("");
    const [photo,setPhoto] = useState(null);
    const [photoError,setPhotoError] =useState("");
    const [file, setFile] = useState(null);
    const [fileError, setFileError] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitMessage, setSubmitMessage] = useState(""); // Holds the success or failure message

    const resetFormState = () => {
      if (formRef.current) {
        formRef.current.reset();
      }
      setFullNameValue("");
      setEmailValue("");
      setContactValue("");
      setExpValue("");
      setCurrentLocation("");
      setPhoto(null);
      setPhotoError("");
      setFile(null);
      setFileError("");
      setIsSubmitting(false);
      setSubmitMessage("");
    };

    // Handle file change
    const handleFileChange = (e) => {
      const uploadedFile = e.target.files[0];
      // console.log("File selected:", uploadedFile);

      const allowedFileTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];

      // Validate file type
      if (uploadedFile && !allowedFileTypes.includes(uploadedFile.type)) {
        setFileError("Invalid file type. Please upload a PDF or Word document.");
        setFile(null); // Clear previous file selection
      } else {
        setFile(uploadedFile);
        setFileError(""); // Clear any previous error
      }
    };

    const handlePhotoChange =(e) =>{
      const uploadedPhoto = e.target.files[0];

      if (!uploadedPhoto) return;

      if (!uploadedPhoto.type.startsWith("image/")) {
          setPhotoError("Please upload a valid image file.");
          setPhoto(null);
          return;
      }

      setPhoto(uploadedPhoto);
      setPhotoError("");
    }

    // Custom function to handle file upload
    const [createJobApplication] = useMutation(CREATE_JOB_APPLICATION);

    const handleSubmit = async (event) => {
      event.preventDefault();
      setIsSubmitting(true);
      setSubmitMessage("");
    
      try {
        const result = await createJobApplication({
          variables: {
            fullName: fullNameValue,
            email: emailValue,
            contact: contactValue,
            exp: expValue,
            current_Loc: currentLocation,
            file: file,
            photo: photo,
          },
        });

        console.log(result,"result");
    
        if (result?.data?.createJobapplication?.success) {
          console.log("Entered Success");
          
          setSubmitMessage("✅ Your application has been successfully submitted. Thank you!");
          setTimeout(() => {
            resetFormState();
            if (typeof props.onHide === "function") {
              props.onHide();
            }
          }, 2000);

        } else {
          setSubmitMessage("❌ Submission failed. Try again.");
          setIsSubmitting(false);
        }
      } 
catch (error) {
  console.error("❌ Submission error:", error);
  if (error.networkError?.result?.errors) {
    setSubmitMessage("❌ " + error.networkError.result.errors[0].message);
  } else {
    setSubmitMessage("❌ An unexpected error occurred.");
  }
  setIsSubmitting(false);
}
    };
    return (
      <>
        {oppturtunityData && oppturtunityData.length > 0 && (
          <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header className="px-4 py-3" closeButton>
              <Modal.Title id="contained-modal-title-vcenter" className='text-white'>
                Job Application
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="px-4 py-3">
              <form ref={formRef} id="job-application-form" className="job-form" onSubmit={handleSubmit}>
                {/* Form Fields */}
                <div className="form-field">
                  <input type="text" name="fullname" id="fullname" required onChange={(event) => {
                    setFullNameValue(event.target.value);
                    // console.log("Full Name entered:", event.target.value);
                  }} />
                  <label htmlFor="fullname">Full Name</label>
                </div>
                <div className="form-field">
                  <input id="email" type="email" name="email" required onChange={(event) => {
                    setEmailValue(event.target.value);
                    // console.log("Email entered:", event.target.value);
                  }} />
                  <label htmlFor="email">Email</label>
                </div>
                <div className="form-field">
                  <input type="tel" name="contact" id="contact" required onChange={(event) => {
                    setContactValue(event.target.value);
                    // console.log("Phone number entered:", event.target.value);
                  }} />
                  <label htmlFor="contact">Phone</label>
                </div>
                <div className="exp form-field">
                  <select value={expValue} required onChange={(event) => {
                    setExpValue(event.target.value);
                    // console.log("Experience selected:", event.target.value);
                  }}>
                    <option disabled value="">Select Experience</option>
                    <option value="0-6 months">0-6 months</option>
                    <option value="6 months-1 year">6 months-1 year</option>
                    <option value="1-2 years">1-2 years</option>
                    <option value="2-3 years">2-3 years</option>
                    <option value="3+ years">3+ years</option>
                  </select>
                </div>
                <div className="form-field">
                  <input type="text" name="current_Loc" id="current_Loc" required onChange={(event) => {
                    setCurrentLocation(event.target.value);
                    // console.log("Current Location entered:", event.target.value);
                  }} />
                  <label htmlFor="current_Loc">Current Location</label>
                </div>

                <div className="form-field floating">
                  <input type="file" name="file" id="file"  accept=".pdf,.doc,.docx" required onChange={handleFileChange} />
                  <label htmlFor='file'>Resume</label>
                  {fileError && <p style={{ color: 'red' }}>{fileError}</p>}
                </div>


                <div className="form-field floating">
                  <input type="file" name="photo" accept="image/*" required onChange={handlePhotoChange} />
                  <label htmlFor='photo'>Candidate Image</label>
                  {photoError && <p style={{ color: 'red' }}>{photoError}</p>}
                </div>  

              </form>
              {/* Success/Failure Message */}
                {submitMessage && (
                  <div style={{ marginTop: '20px', color: submitMessage.includes('success') ? 'green' : 'red' }}>
                    {submitMessage}
                  </div>
                )}
            </Modal.Body>
            <Modal.Footer className="px-4 py-3 d-flex justify-content-end">
              <Button
                variant="success"
                type="submit"
                form="job-application-form"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit Application"}
              </Button>
              <Button className="ml-2" variant="danger" onClick={props.onHide}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </>
    );
  };

  return (
    <ApolloProvider client={APOLLO_CLIENT}>
      <JobForm />
    </ApolloProvider>
  );
};

export default JobModal;
